<template>
    <div>
        <div>
            <span class="form-label">Building/Structure Details</span>
        </div>
        <div class="building-list">
            <el-table :data="buildingList" class="w-100">
                <el-table-column class-name="action-column" width="120" v-if="!readOnly">
                    <template slot="header">
                        <div>
                            <el-button
                                class="w-100 p-5px"
                                size="small"
                                type="primary"
                                icon="el-icon-refresh"
                                @click="updateCustomerValues()"
                                >{{ $t('Update Values') }}</el-button
                            >
                        </div>
                        <div class="mt-10px">
                            <el-button
                                class="w-100 p-5px"
                                size="small"
                                type="primary"
                                icon="el-icon-plus"
                                @click="addClick()"
                                >{{ $t('Add New') }}</el-button
                            >
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="action-buttons">
                            <div>
                                <div>
                                    <el-button
                                        class="up-down-action"
                                        icon="el-icon-top"
                                        size="mini"
                                        circle
                                        :disabled="scope.$index == 0"
                                        @click="onUpDownClick(scope.$index, 'up')"
                                    >
                                    </el-button>
                                </div>
                                <div>
                                    <el-button
                                        class="up-down-action"
                                        icon="el-icon-bottom"
                                        size="mini"
                                        circle
                                        :disabled="scope.$index == buildingList.length - 1"
                                        @click="onUpDownClick(scope.$index, 'down')"
                                    >
                                    </el-button>
                                </div>
                            </div>
                            <el-button
                                icon="el-icon-edit"
                                size="small"
                                circle
                                @click="editClick(scope.row)"
                            ></el-button>
                            <el-button
                                icon="el-icon-delete"
                                size="small"
                                circle
                                @click="deleteClick(scope.$index)"
                            ></el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="type" :label="$t('Type')"> </el-table-column>
                <el-table-column prop="name" :label="$t('Name')"> </el-table-column>
                <el-table-column align="center">
                    <template slot="header">
                        <div>{{ $t('Building Value') }}</div>
                        <div ref="customerBuildingValue" v-if="customerBuildingValue">
                            ({{ customerBuildingValue }})
                        </div>
                    </template>
                    <el-table-column prop="building_value_percentage" label="%" align="center">
                    </el-table-column>
                    <el-table-column label="AED" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.buildingValueTotal }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column align="center">
                    <template slot="header">
                        <div>{{ $t('Plant Value') }}</div>
                        <div ref="customerPlantValue" v-if="customerPlantValue">
                            ({{ customerPlantValue }})
                        </div>
                    </template>
                    <el-table-column prop="plant_value_percentage" label="%" align="center">
                    </el-table-column>
                    <el-table-column prop="plant_value" label="AED" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.plantValueTotal }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column align="center">
                    <template slot="header">
                        <div>{{ $t('Stock Value') }}</div>
                        <div ref="customerStockValue" v-if="customerStockValue">
                            ({{ customerStockValue }})
                        </div>
                    </template>
                    <el-table-column prop="stock_value_percentage" label="%" align="center">
                    </el-table-column>
                    <el-table-column prop="stock_value" label="AED" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.stockValueTotal }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column align="center">
                    <template slot="header">
                        <div>{{ $t('Other Value') }}</div>
                        <div ref="customerOtherValue" v-if="customerOtherValue">
                            ({{ customerOtherValue }})
                        </div>
                    </template>
                    <el-table-column prop="other_value_percentage" label="%" align="center">
                    </el-table-column>
                    <el-table-column prop="other_value" label="AED" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.otherValueTotal }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column align="center">
                    <template slot="header">
                        <div>{{ $t('BI Value') }}</div>
                        <div ref="customerBIValue" v-if="customerBIValue">
                            ({{ customerBIValue }})
                        </div>
                    </template>
                    <el-table-column prop="bi_value_percentage" label="%" align="center">
                    </el-table-column>
                    <el-table-column prop="bi_value" label="AED" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.biValueTotal }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="$t('Total')" align="center">
                    <el-table-column label="AED" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.total }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog
            v-if="buildingModal"
            :title="buildingItem ? buildingItem.name : null"
            :visible.sync="buildingModal"
            append-to-body
            :close-on-click-modal="false"
        >
            <el-form label-width="120px" label-position="top">
                <el-form-item :label="$t('Building Type')">
                    <el-select
                        v-model="buildingItem.type"
                        :placeholder="$t('Please select type')"
                        filterable
                        class="w-100"
                        size="small"
                    >
                        <el-option
                            v-for="item in buildingItemTypes"
                            :key="item"
                            :label="item"
                            :value="item"
                        >
                            <span>{{ item }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Building Name')">
                    <el-input
                        :placeholder="$t('Name')"
                        v-model="buildingItem.name"
                        size="small"
                        class="w-100"
                    />
                </el-form-item>
                <el-form-item :label="$t('Building Value Percentage')">
                    <el-input
                        :placeholder="$t('Percentage')"
                        v-model="buildingItem.building_value_percentage"
                        size="small"
                        class="w-25 text-align-left"
                        :controls="false"
                    />
                </el-form-item>
                <el-form-item :label="$t('Plant Value Percentage')">
                    <el-input
                        :placeholder="$t('Percentage')"
                        v-model="buildingItem.plant_value_percentage"
                        size="small"
                        class="w-25 text-align-left"
                        :controls="false"
                    />
                </el-form-item>
                <el-form-item :label="$t('Stock Value Percentage')">
                    <el-input
                        :placeholder="$t('Percentage')"
                        v-model="buildingItem.stock_value_percentage"
                        size="small"
                        class="w-25 text-align-left"
                        :controls="false"
                    />
                </el-form-item>
                <el-form-item :label="$t('Other Value Percentage')">
                    <el-input
                        :placeholder="$t('Percentage')"
                        v-model="buildingItem.other_value_percentage"
                        size="small"
                        class="w-25 text-align-left"
                        :controls="false"
                    />
                </el-form-item>
                <el-form-item :label="$t('BI Value Percentage')">
                    <el-input
                        :placeholder="$t('Percentage')"
                        v-model="buildingItem.bi_value_percentage"
                        size="small"
                        class="w-25 text-align-left"
                        :controls="false"
                    />
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button class="el-button--primary" @click="save">{{ $t('Complete') }}</el-button>
                <el-button @click="cancel">{{ $t('Cancel') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import FormQuestion from '@/data/FormQuestion';
import Collection from '@/lib/data/Collection';
import BuildingRSA from '@/data/BuildingRSA';
import Visit from '@/data/Visit';

export default {
    props: {
        question: {
            type: FormQuestion,
            default: new FormQuestion(),
        },
        value: {
            type: Array,
            default: new Collection({
                model: BuildingRSA,
            }),
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        visit: {
            type: Visit,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            buildingItem: null,
            buildingModal: false,
            buildingList: null,
            buildingItemTypes: ['Building', 'Structure'],
            customerBuildingValue: null,
            customerPlantValue: null,
            customerStockValue: null,
            customerOtherValue: null,
            customerBIValue: null,
        };
    },
    created() {
        this.buildingList = this.value;
    },
    mounted() {
        this.setCustomerValues();
    },
    watch: {
        customerValues() {
            this.setCustomerValues();
        },
    },
    methods: {
        onUpDownClick(index, direction) {
            if (direction == 'up') {
                this.buildingList.splice(index - 1, 0, this.buildingList.splice(index, 1)[0]);
            } else {
                this.buildingList.splice(index + 1, 0, this.buildingList.splice(index, 1)[0]);
            }
        },
        editClick(data) {
            this.buildingItem = data;
            this.buildingModal = true;
        },
        deleteClick(index) {
            this.buildingList.splice(index, 1);
        },
        addClick() {
            this.buildingItem = new BuildingRSA();
            this.buildingModal = true;
        },
        save() {
            this.buildingModal = false;
            this.buildingItem.commit();
            this.buildingList.add(this.buildingItem);
        },
        cancel() {
            this.buildingModal = false;
            this.buildingItem.reject();
        },
        setCustomerValues() {
            if (this.readOnly === false) {
                let { building_value, plant_value, stock_value, other_value, gross_profit_value } =
                    this.visit.address;

                if (this.buildingList.length) {
                    building_value = this.buildingList[0].building_value;
                    plant_value = this.buildingList[0].plant_value;
                    stock_value = this.buildingList[0].stock_value;
                    other_value = this.buildingList[0].other_value;
                    gross_profit_value = this.buildingList[0].bi_value;
                }

                this.customerBuildingValue = building_value;
                this.customerPlantValue = plant_value;
                this.customerStockValue = stock_value;
                this.customerOtherValue = other_value;
                this.customerBIValue = gross_profit_value;

                if (this.$refs.customerBuildingValue) {
                    this.$refs.customerBuildingValue.innerHTML = `(${this.customerBuildingValue})`;
                    this.$refs.customerPlantValue.innerHTML = `(${this.customerPlantValue})`;
                    this.$refs.customerStockValue.innerHTML = `(${this.customerStockValue})`;
                    this.$refs.customerOtherValue.innerHTML = `(${this.customerOtherValue})`;
                    this.$refs.customerBIValue.innerHTML = `(${this.customerBIValue})`;
                }
            }
        },
        updateCustomerValues() {
            const { building_value, plant_value, stock_value, other_value, gross_profit_value } =
                this.visit.address;

            this.buildingList.forEach((item) => {
                item.building_value = building_value;
                item.plant_value = plant_value;
                item.stock_value = stock_value;
                item.other_value = other_value;
                item.bi_value = gross_profit_value;
            });

            this.setCustomerValues();
        },
    },
};
</script>
<style lang="scss">
.building-list {
    .action-column {
        .cell {
            overflow: visible;
        }

        .action-buttons {
            display: flex;
            align-items: center;
            justify-content: space-evenly;

            .el-button {
                margin: 0px;
            }

            .up-down-action {
                padding: 3px;
            }
        }
    }
}
</style>
